<h2 mat-dialog-title>{{ title | translate }}</h2>

<mat-dialog-content>
  <p class="paragraphText mb-4">{{ description | translate: descriptionParams }}</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button type="button" class="btn outlineActionButton" [mat-dialog-close]="false">{{ cancelBtnLabel | translate }}</button>
  <button mat-button type="button" class="btn" [class.warnButton]="isDeleteAction" [class.actionButton]="!isDeleteAction" [mat-dialog-close]="true">
    {{ confirmBtnLabel | translate }}
  </button>
</mat-dialog-actions>
